export default "__VITE_ASSET__4a00c013__"